import { render, staticRenderFns } from "./StatementReferences.vue?vue&type=template&id=0053c729&"
import script from "./StatementReferences.vue?vue&type=script&lang=js&"
export * from "./StatementReferences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports